module.exports = __webpack_public_path__ + "static/pic01-3eac4dfb1aa52a153c45a99febf89419.jpg";